import IContextDocument from "./IContextDocument";
import Document from "./Document";
import IGbContext from "../../interfaces/IGbContext";

export default class CoreDocument implements IContextDocument {
    document: Document;
    coreContext: IGbContext;

    constructor(document: Document, coreContext: IGbContext) {
        this.document = document;
        this.coreContext = coreContext;
    }
}
